import { Project, PomodoroRecord } from '../types/project';
import { Task } from '../types/task';

export function snakeToCamel<T>(obj: Record<string, any>): T {
  const result: Record<string, any> = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const camelKey = key.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
      result[camelKey] = obj[key];
    }
  }
  return result as T;
}

export const mapProjectFromDb = (row: any): Project => snakeToCamel<Project>(row);

export const mapTaskFromDb = (row: any): Task => {
  const task = snakeToCamel<Task>(row);
  task.completed = task.status === 'completed';
  return task;
};

// PostgreSQL sometimes returns timestamps without timezone suffix (e.g. "2026-04-01T10:36:00").
// Without the 'Z'/'+00:00' suffix, new Date() treats the string as LOCAL time in V8/Chrome,
// causing a timezone shift. We force UTC interpretation by appending 'Z' when needed.
const parseDbTimestamp = (ts: string | null | undefined): number | undefined => {
  if (!ts) return undefined;
  const normalized = /[Zz]$|[+-]\d{2}:?\d{2}$/.test(ts)
    ? ts
    : ts.replace(' ', 'T') + 'Z';
  const ms = new Date(normalized).getTime();
  return isNaN(ms) ? undefined : ms;
};

export const mapPomodoroFromDb = (row: any): PomodoroRecord => {
  const record = snakeToCamel<PomodoroRecord>(row);
  if (row.start_time != null) record.startTime = parseDbTimestamp(row.start_time);
  if (row.end_time != null) record.endTime = parseDbTimestamp(row.end_time);
  return record;
};
